import { RessortModuleEntry } from "../helper/interfaces";
import React from "react";
import Loading from "./ui/Loading";
import { ChevronDown } from "react-feather";
import { AppTheme } from "../helper/enums";

interface Data {
  module: RessortModuleEntry;
  loadMore: (id: string, searchParams?: any, restPage?: boolean) => void;
  isLoadingMore: boolean;
}

function LoadMore(data: Data) {
  const moduleData = data.module;
  const loadMore = data.loadMore;
  const isLoadingMore = data.isLoadingMore;
  const isNB = process.env.NEXT_PUBLIC_APP_THEME === AppTheme.nb;

  return (
    <>
      {moduleData.loadMore && !isLoadingMore && (
        <div className="teasers-more space-bottom-xl space-top-xl">
          <button
            className="more-btn flex justify-center gap-1 mx-auto items-center"
            type="button"
            onClick={(event) => {
              event.preventDefault();
              loadMore(moduleData.id);
            }}
            aria-label="Mehr laden"
          >
            <span className={isNB ? "pt-mini" : undefined}>Mehr laden</span> <span><ChevronDown /></span>
          </button>
        </div>
      )}
      {isLoadingMore && (
        <div className="teasers-more">
          <Loading inline={true} />
        </div>
      )}
      {/* Divider 
        <div className="section-divider space-bottom"></div>
      */}
    </>
  );
}

export default LoadMore;
